import { Routes, Route, useLocation } from 'react-router-dom';
import Login from '../common/pages/login/Login';
import PrivateRouteApp from './PrivateRouteApp';
import PramaLink from '../common/pages/deliverytracking/pramalink/PramaLink';
import ForgetPassword from '../common/pages/forget-password/ForgetPassword';
import LandingPage from '../common/pages/landing/LandingPage';
import About from '../common/pages/landing/componenets/about/About';
import { Contact } from '../common/pages/landing/componenets/contact/Contact';
import { PrivacyPolicy } from '../common/pages/landing/componenets/privacypolicy/PrivacyPolicy';
import { TermsCondtions } from '../common/pages/landing/componenets/termscondtions/TermsCondtions';
import Trips from '../features/deliverytracking/pages/trips/Trips';
import Orders from '../features/deliverytracking/pages/trips/orders/Orders';
import ViewOrders from '../features/deliverytracking/pages/trips/orders/ViewOrders';
import TripTracking from '../common/components/tracking/TripTracking';
import { TripView } from '../common/pages/user/trips/components/mytrips/TripView';
import PassengerTripTracking from '../features/autoplanner/pages/trips/scheduled/components/PassengerTripTracking';
import { useAppSelector } from '../app/redux/hooks';

function PublicRoutes() {
  let token = localStorage.getItem('token');
  let status = localStorage.getItem('status');
  const { pathname } = useLocation();
  const { loginAccess } = useAppSelector(state => state.RoleModuleAccess);

  return (
    <Routes>
      <Route
        path='*'
        element={
          (token !== null || status) && pathname.split('/')[1] !== 'trip-tracking' ? (
            <PrivateRouteApp />
          ) : (
            <LandingPage />
          )
        }
      />
      <Route path='/home' element={<LandingPage />} />
      <Route path='/about' element={<About />} />
      <Route path='/contact' element={<Contact />} />
      <Route path='/privacypolicy' element={<PrivacyPolicy />} />
      <Route path='/terms&conditions' element={<TermsCondtions />} />
      <Route path='/login' element={<Login />} />
      <Route path='/forgetpassword' element={<ForgetPassword />} />
      {/* <Route path='/deliverytracking' element={<Trips />} /> */}

      {/* <Route path='/vieworders' element={<ViewOrders />} /> */}
      <Route path='/customerordertracking' element={<PramaLink />} />
      <Route path='/triptracking' element={<TripTracking />} />
      <Route path='/tracking' element={<PassengerTripTracking />} />
    </Routes>
  );
}

export default PublicRoutes;
